import React, { useState, useEffect } from "react";
import "./Category.css";
import axios from "../api/axios";
import { Link } from "react-router-dom"; //Link

function Category() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get('/categories')
      .then(response => {
        if (response.data && response.data.data) {
          setCategories(response.data.data);
        }
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  return (
    <>
      <div className="category_outer_main">
        <div className="container-fluid">
         
            <div className="category_outer_box">

              {categories.map((category) => (
                <div className="category_item" key={category.id}>
                 <Link to={`/products?category=${category.slug}`} className="category_item_outer">  
                    <img src={category.icon || category.banner} alt={category.name} />
                    <div className="category_text">
                      <Link to={`/products?category=${category.slug}`}>{category.name}</Link>
                    </div>
                  </Link>
                </div>
              ))}
              
            </div>
          
        </div>
      </div>
    </>
  );
}

export default Category;
